import { formatPriceWithCurrency } from '~utils/PriceFormatter';

export const getFormattedPrice = ({
    price,
    fallback,
    free = false
}: {
    price: number;
    fallback: string;
    free?: boolean;
}) => {
    const isFree = free && price === 0;
    const priceFromFallback = fallback?.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/gm);
    const formattedFallback = priceFromFallback?.length
        ? formatPriceWithCurrency(parseFloat(priceFromFallback[0].replace(',', '.')))
        : fallback;

    return price !== undefined && !isFree ? formatPriceWithCurrency(price) : formattedFallback;
};
